import { StyledLabelBadge } from './StyledLabelBadge';

export default StyledLabelBadge;
